import "./style/index.scss";
import "./style/colors.scss";
import App from "./app";

export default App;
